import styled, { css } from 'styled-components';
import arrowLeft from '~/assets/icons/arrow_left.svg';
import { Text } from '../Text';
import { SelectColorSize } from './SelectColor.model';

const StyledWrapper = styled.div<{ $size: SelectColorSize; $count: number }>`
	position: relative;
	width: ${(props) =>
		props.$count * props.$size + props.$count * 10 + props.$size * 2 + 20}px;
	height: ${(props) => props.$size}px;
`;

const StyledContainer = styled.div<{ $size: SelectColorSize }>`
	${(props) =>
		props.$size === SelectColorSize.Size20 &&
		css`
			position: absolute;
			top: -5px;
			left: 0;
		`}

	display: flex;
	align-items: center;
	gap: 20px;
	height: 30px;

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledColorsContainer = styled.div<{
	$size: SelectColorSize;
	$count: number;
}>`
	display: flex;
	gap: 10px;
	width: ${(props) => props.$count * props.$size + (props.$count - 1) * 10}px;
	height: 30px;
	${(props) =>
		props.$size === SelectColorSize.Size20 &&
		css`
			padding-top: 5px;
		`}
	overflow-x: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledColorWrapper = styled.div<{ $size: SelectColorSize }>`
	position: relative;
	width: ${(props) => props.$size}px;
	min-width: ${(props) => props.$size}px;
	height: ${(props) => props.$size}px;
	min-height: ${(props) => props.$size}px;
`;

const StyledColor = styled.div<{
	$color: string;
	$selected?: boolean;
	$size: SelectColorSize;
}>`
	position: relative;
	${(props) =>
		props.$size === SelectColorSize.Size20 &&
		css`
			left: 5px;
			top: 5px;
		`}
	width: ${(props) => props.$size}px;
	min-width: ${(props) => props.$size}px;
	height: ${(props) => props.$size}px;
	min-height: ${(props) => props.$size}px;
	border-radius: ${(props) => props.$size}px;
	background-color: ${(props) => props.$color};
	border: 2px solid transparent;
	transition: border 0.3s ease;

	${(props) =>
		props.$selected &&
		css`
			border: ${props.$size === SelectColorSize.Size20 ? '1px' : '2px'} solid
				#2d70da;
		`}
`;

const StyledColorContainer = styled.div<{ $size: SelectColorSize }>`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 30px;
	height: 30px;
	min-width: 30px;
	min-height: 30px;
	cursor: pointer;

	&:hover {
		${StyledColor} {
			border: ${(props) =>
					props.$size === SelectColorSize.Size20 ? '1px' : '2px'}
				solid #2d70da;
		}
	}
`;

const StyledRightContainer = styled.div`
	display: flex;
	gap: 10px;
`;

const StyledArrow = styled.div`
	width: 10px;
	height: 10px;
	mask-position: center;
	mask-repeat: no-repeat;
	mask-image: url(${arrowLeft});
	mask-size: 10px 10px;
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-image: url(${arrowLeft});
	-webkit-mask-size: 10px 10px;
	background-color: #ffffff;
	transition:
		background-color 0.3s ease,
		opacity 0.3s ease;
`;

const StyledButtonContainer = styled.div<{
	$size: SelectColorSize;
	$disabled?: boolean;
}>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: ${(props) => props.$size}px;
	height: ${(props) => props.$size}px;
	border-radius: ${(props) => props.$size}px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	${(props) =>
		props.$disabled
			? css`
					background-color: rgba(255, 255, 255, 0.02);
					border: 1px solid rgba(255, 255, 255, 0.05);

					${StyledArrow} {
						opacity: 0.25;
					}
			  `
			: css`
					background-color: rgba(255, 255, 255, 0.05);
					border: 1px solid rgba(255, 255, 255, 0.1);

					&:hover {
						background-color: #ffffff;

						${StyledArrow} {
							background-color: #000000;
						}
					}
			  `}
`;

export {
	StyledArrow,
	StyledButtonContainer,
	StyledColor,
	StyledColorContainer,
	StyledColorsContainer,
	StyledColorWrapper,
	StyledContainer,
	StyledRightContainer,
	StyledWrapper,
};
